export type ChangelogCategory = "feature" | "improvement" | "fix"

// URL de base des tickets GitHub (repo central de suivi = agora)
export const CHANGELOG_GITHUB_ISSUES_BASE_URL = "https://github.com/ctsDevel/agora/issues/"

// Nouvelle interface pour un élément individuel
export interface ChangelogItem {
     text: string
     tags?: string[] // Tags optionnels
     issues?: number[] // Numéros de ticket GitHub — lien visible uniquement par ROLE_SUPER_ADMIN
}

// Clés des deux sous-catégories de la section interne
export type ChangelogInternalCategory = "functional" | "technical"

export interface ChangelogEntry {
     id: number
     version: string
     date: string
     title: string
     changes: {
          // On utilise maintenant ChangelogItem au lieu de string
          feature?: ChangelogItem[]
          improvement?: ChangelogItem[]
          fix?: ChangelogItem[]
     }
     // Tickets internes (Dev, Refactor) — visibles uniquement par
     // ROLE_SUPER_ADMIN / ROLE_IT / ROLE_PRESIDENT / ROLE_DG, en pied de version.
     // Répartis en deux sous-catégories : fonctionnel interne vs technique.
     internal?: {
          functional?: ChangelogItem[] // Fonctionnalités & correctifs internes
          technical?: ChangelogItem[] // Architecture, développement, framework & technique
     }
}

export const CH_CATEGORIES: Record<ChangelogCategory, { label: string; color: string; icon: string }> = {
     feature: { label: "Nouveauté", color: "primary", icon: "bi-rocket-takeoff" },
     improvement: { label: "Amélioration", color: "info", icon: "bi-stars" },
     fix: { label: "Correction de bug", color: "success", icon: "bi-patch-check" },
}

// Libellés/icônes des deux sous-catégories internes (ordre d'affichage)
export const CH_INTERNAL_CATEGORIES: Record<ChangelogInternalCategory, { label: string; icon: string }> = {
     functional: { label: "Fonctionnalités & correctifs internes", icon: "bi-box-seam" },
     technical: { label: "Architecture, développement & technique", icon: "bi-tools" },
}
